import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { useBrand } from "@webuild-ai/react-ui/hooks";
import { BrandLogo } from "@webuild-ai/react-ui/components";

import { title, subtitle } from "@/components/primitives";
import MenuCard from "@/components/MenuCard/MenuCard";
import { getDashboardConfig } from "@/config/dashboards";

export default function IndexPage() {
  const { t } = useTranslation();
  const { brand } = useBrand();
  const dashboard = getDashboardConfig(brand.folder);

  // Redirect to dashboard if configured as the default landing page
  // but only if showInSideBar is false (dashboard should be accessed via sidebar instead)
  if (dashboard?.url && !dashboard.showInSideBar) {
    return <Navigate replace to={`/${dashboard.urlSegment ?? "dashboard"}`} />;
  }

  return (
    <>
      <section className="flex flex-col items-center justify-center gap-4 py-4">
        <div className="flex flex-col items-center justify-center text-center title-section w-full">
          {brand.layout.showLogo ? (
            <BrandLogo
              className="mx-auto"
              style={{ height: brand.layout.menuItemsIconSize ?? 60 }}
            />
          ) : (
            <span className={title()}>{brand.name}&nbsp;</span>
          )}
          <br />
          <div className={subtitle({ class: `${!brand.layout.showLogo ? "mt-4" : ""}` })}>
            {brand.subtitle ? t(brand.subtitle) : t("Your AI Platform")}
          </div>
        </div>
        <MenuCard />
      </section>
    </>
  );
}
